import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'features/home',
    pathMatch: 'full'
  },
  {
    path: 'login',
    children: [
      {
        path: ':company',
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule),
      },
      {
        path: '',
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule),
      },
    ]
  },
  {
    path: 'features',
    loadChildren: () => import('./pages/features.module').then(m => m.FeaturesModule),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }

